import { fontFamily } from '@atlaskit/theme';
export const charlieDisplayFontFamily = () => "Charlie Display', ".concat(fontFamily());